import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const state = () => ({
  selectCandidate: {},
});

const getters = {
  saveSelectCandidate: (state) => state.selectCandidate,
};

const mutations = {
  saveSelectCandidate(state, payload) {
    state.selectCandidate = payload;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
